

























import { Vue, Component, Prop } from "vue-property-decorator";
import { InputDependency, TemplateInput } from "@/store/template/types";

@Component
export default class DependencyTile extends Vue {
  @Prop() input!: TemplateInput;
  @Prop() index!: number;
  @Prop() dependency!: InputDependency;

  remove() {
    this.input.depends_on.splice(this.index, 1);
  }
}
